import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://destinationweddingsandevents.in';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical: canonicalProp,
  ogImage = 'https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80',
  ogType = 'website',
  schemaType = null,
  schemaData = null,
  noIndex = false
}) => {
  const { pathname } = useLocation();
  const canonical = canonicalProp || `${SITE_URL}${pathname === '/' ? '/' : pathname.replace(/\/+$/, '')}`;
  const siteTitle = 'Destination Weddings & Events';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;

  // Drop index.html's homepage fallback tags so every page exposes only its own title/description/canonical
  useEffect(() => {
    document.querySelectorAll('[data-static-seo]').forEach((el) => el.remove());
  }, []);
  
  return (
    <>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"} />
      <meta name="googlebot" content={noIndex ? "noindex, nofollow" : "index, follow"} />
      {!noIndex && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:site_name" content="Destination Weddings & Events" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Schema.org structured data */}
      {schemaType && schemaData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify({ "@context": "https://schema.org", "@type": schemaType, ...schemaData }) }}
        />
      )}
    </>
  );
};

export default SEO;
